import React from "react";
import { Col, Row, Timeline, Typography } from "antd";
import AppModalWrapper from "../components/Items/Modal/AppModalWrapper";
import { useSelector } from "react-redux";
import { RootState } from "../redux-toolkit/store/store";
import { formatDateInMMDDYYYY } from "../helpers/date";
const { Title } = Typography;

const ViewPainTrackingExtendedNotesModal: React.FC<GeneralModalProps> = ({
  show,
  handleClose,
}) => {
  const { userPainData } = useSelector((state: RootState) => state.dashboard);
  return (
    <>
      <AppModalWrapper
        title="View Pain Tracking Notes"
        headerStyle={{
          backgroundColor: "#f5f5f5",
          color: "#101828",
          fontSize: "16px",
          fontWeight: "700",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          handleClose(false);
        }}
      >
        <Row>
          <Col span={24} style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ margin: "20px" }}>
              <Title level={5}>Notes</Title>
              <Timeline>
                {userPainData.notes.map((note) => (
                  <Timeline.Item key={note.note}>
                    <span style={{ color: "#475467" }}>
                      {formatDateInMMDDYYYY(new Date(note.createdAt), false)}
                    </span>{" "}
                    - <span style={{ color: "#101828" }}>{note.note}</span>
                  </Timeline.Item>
                ))}
              </Timeline>
            </div>
          </Col>
        </Row>
      </AppModalWrapper>
    </>
  );
};
export default ViewPainTrackingExtendedNotesModal;
